import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import InvoiceGalleryMarquee from './components/InvoiceGalleryMarquee';
import InvoiceDesignForm from './components/InvoiceDesignForm';

export default function CustomInvoiceDesign() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 animate-fade-in-up">
            Request a Custom Invoice Design
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto animate-fade-in-up">
            <span className="block mb-3" style={{ color: '#0089D8' }}>
              Use the Xero biomail invoice layout with your own preferred image header for Free.
            </span>
            <span className="block mb-3">
              Or would you prefer to create an invoice layout that matches your brand perfectly?
            </span>
            <span className="block">
              Tell us what you have in mind and our design team will craft a bespoke layout just for your
              business for a one time standard nominal design and setup fee.
            </span>
          </p>
        </div>
      </section>

      {/* Invoice Gallery Marquee */}
      <section className="py-16 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-10 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Explore the possibilities
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            A glimpse at some of the styles we can create — from clean and minimal to bold and branded.
          </p>
        </div>
        <InvoiceGalleryMarquee />
      </section>

      {/* Form Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            {/* Left: info */}
            <div className="lg:sticky lg:top-28">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Let's design something great
              </h2>
              <p className="text-gray-600 mb-8">
                Just share a few details and we'll get back to you. No commitment required —
                it's the first step to a layout that's uniquely yours.
              </p>

              <div className="space-y-6">
                {[
                  {
                    icon: 'ri-mail-send-line',
                    title: 'Tell us what you need',
                    text: 'Share your details and, if you have one, an example of your current design.',
                  },
                  {
                    icon: 'ri-palette-line',
                    title: 'We craft a draft',
                    text: 'Our team designs a bespoke invoice layout based on your brand and requirements.',
                  },
                  {
                    icon: 'ri-loop-right-line',
                    title: 'Refine together',
                    text: 'We iterate with you until it looks exactly the way you want.',
                  },
                  {
                    icon: 'fa-solid fa-dollar-sign',
                    title: 'Design and Development',
                    text: 'A one time only design and development cost of US $265 applies. This covers up to 5 iterations of your design to fine tune to your requirements.',
                  },
                ].map((step) => (
                  <div key={step.title} className="flex items-start gap-4">
                    <div className="w-11 h-11 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${step.icon} text-blue-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">{step.title}</h3>
                      <p className="text-gray-600 text-sm">{step.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-10 p-5 bg-white rounded-xl border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Prefer to email us directly?</p>
                <a
                  href="mailto:sales@bio-mail.com"
                  className="text-blue-600 hover:text-blue-700 transition-colors font-medium text-sm"
                >
                  sales@bio-mail.com
                </a>
              </div>
            </div>

            {/* Right: form */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
              <InvoiceDesignForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}